import React from 'react';
import { Paper, Grid } from '@mui/material';
import SortFilter from './SortFilter';
import YearFilter from './YearFilter';
import CitationFilter from './CitationFilter';
import SearchFilter from './SearchFilter';
import FieldsFilter from './FieldsFilter';

const FilterBar = ({ filters, onFilterChange }) => {
  const handleChange = (filterName, value) => {
    onFilterChange({ ...filters, [filterName]: value });
  };

  return (
    <Paper 
      elevation={0}
      sx={{ 
        p: 3, 
        mb: 3, 
        bgcolor: '#f8f9fa',
        borderRadius: '16px',
        border: '1px solid rgba(0,0,0,0.1)'
      }}
    >
      <Grid container spacing={3} alignItems="center">
        <Grid item xs={12} sm={6} md={3}>
          <SortFilter 
            value={filters.sortBy}
            onChange={(value) => handleChange('sortBy', value)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <YearFilter 
            value={filters.yearFilter}
            onChange={(value) => handleChange('yearFilter', value)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <CitationFilter 
            value={filters.minCitations}
            onChange={(value) => handleChange('minCitations', value)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <SearchFilter 
            value={filters.searchQuery}
            onChange={(value) => handleChange('searchQuery', value)}
          />
        </Grid>
        <Grid item xs={12}>
          <FieldsFilter 
            value={filters.selectedFields}
            onChange={(value) => handleChange('selectedFields', value)}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default FilterBar; 